import {computed, ComputedRef} from "vue"
import transportPackCode from "@/config/transportPackCode"
import store from "@/vue/planning/store/store"

const availableTransportPackCodes: ComputedRef<Array<any>> = computed(() => {
    const availableTransportPackCodes = store.getters.availablePackCodes.filter((codeObjPackage: any) => {
        if (transportPackCode.includes(codeObjPackage.codePackage)) return true;
    });

    return availableTransportPackCodes;
})

export default availableTransportPackCodes